<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M15.3355 9.02328L10.273 14.0858C10.1674 14.1913 10.0243 14.2506 9.875 14.2506C9.72573 14.2506 9.58258 14.1913 9.47703 14.0858C9.37148 13.9802 9.31219 13.8371 9.31219 13.6878C9.31219 13.5385 9.37148 13.3954 9.47703 13.2898L13.5798 9.18781H2.5625C2.41332 9.18781 2.27024 9.12855 2.16475 9.02306C2.05926 8.91757 2 8.7745 2 8.62531C2 8.47613 2.05926 8.33305 2.16475 8.22757C2.27024 8.12208 2.41332 8.06281 2.5625 8.06281H13.5798L9.47703 3.96078C9.37148 3.85523 9.31219 3.71208 9.31219 3.56281C9.31219 3.41355 9.37148 3.27039 9.47703 3.16484C9.58258 3.0593 9.72573 3 9.875 3C10.0243 3 10.1674 3.0593 10.273 3.16484L15.3355 8.22734C15.3878 8.27958 15.4293 8.34162 15.4576 8.40991C15.4859 8.4782 15.5004 8.55139 15.5004 8.62531C15.5004 8.69923 15.4859 8.77243 15.4576 8.84072C15.4293 8.909 15.3878 8.97104 15.3355 9.02328Z"
      fill="#373C44"
    />
  </svg>
</template>

<script>
export default {
  name: 'GreyArrowRight18'
};
</script>

<style scoped>

</style>